import { inject, Injectable } from '@angular/core';
import { NotificationModel } from '@app/pages/notifications/models/notification-model';
import { getIconUrl } from './helpers/notif-icon.helper';
import { getOnClickUrl } from './helpers/notif-url.helper';
import { INotificationData } from './model/notification.model';
import { NotificationStrategyFactory } from './factory/notification-strategy-factory';

@Injectable({
  providedIn: 'root'
})

/**
 * Generates full notification data for Firebase push notifications.
 * Includes message text, icon URL, and click URL.
 */
export class FirebaseNotificationGeneratorService {
  private factory = inject(NotificationStrategyFactory);

  public generateNotification(payload: NotificationModel, receiver: string, imageUrl: string, siteUrl: string): INotificationData {
    const activity = payload?.activity!;
    const verb = activity?.verb;
    const iconUrl = getIconUrl(imageUrl, activity);
    const onClickUrl = getOnClickUrl(siteUrl, activity);
    const strategy = this.factory.create(verb!);
    const message = strategy.createText(activity, receiver, true);


    return { message, iconUrl, onClickUrl } as INotificationData;
  }
}
